import { useEffect, useState } from "react";
import { Button, Card, Col, Form, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import "../style.css";
import { Translate } from "../../../../Enums/Tranlate";

const EditEmployeeModal = ({
	modal,
	setModal,
	item,
	setShouldUpdate,
	type,
}) => {
	const lang = useSelector((state) => state.auth.lang);
	const [formData, setFormData] = useState({
		first_name: "",
		last_name: "",
		date_of_birth: "",
		gender: "",
		employee_id: "",
		date_of_join: "",
		email: "",
		address: "",
		department: "",
		employee_designation: "",
		starting_date: "",
		complete_date: "",
	});
	const options = [
		{ label: Translate[lang].male, value: "male" },
		{ label: Translate[lang].female, value: "female" },
	];
	const [loading, setLoading] = useState(false);

	// useEffect(() => {
	// 		setFormData({
	// 			id: item?.id,
	// 		});
	// }, [item]);

	const submit = (e) => {
		e.preventDefault();
		let data = {};

		setLoading(true);
		//     Service.update(formData?.id, data)?.then(res=>{
		//         if(res && res?.status === 200){
		//             toast.success(`${type === 'departments' ? Translate[lang]?.department : Translate[lang]?.unit} Updated Successfully`)
		//             setShouldUpdate(prev=> !prev)
		//             setModal()
		//         }
		//         setLoading(false)
		//     }).catch(()=>setLoading(false))
	};

	return (
		<Modal
			className={
				lang === "en" ? "en fade editEmployee" : "ar fade addDepartment"
			}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={modal}
			onHide={() => {
				setModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<div className="mb-3 d-flex justify-content-between">
						<p className="mb-0 fs-18 text-black fw-500">
							{Translate[lang][type]}
						</p>
						<Button
							variant=""
							className="close"
							style={{
								right: lang === "en" ? "0" : "auto",
								left: lang === "ar" ? "0" : "auto",
							}}
							onClick={() => {
								setModal();
							}}>
							<span style={{ fontSize: "22px" }}>&times;</span>
						</Button>
					</div>
					{type === "personal_information" && (
						<Card>
							<Card.Body>
								<Row>
									<Col md={6}>
										<AvField
											label={Translate[lang]?.first_name}
											type="text"
											placeholder={Translate[lang]?.first_name}
											bsSize="lg"
											name="first_name"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.first_name}
											onChange={(e) =>
												setFormData({ ...formData, first_name: e.target.value })
											}
										/>
									</Col>
									<Col md={6}>
										<AvField
											label={Translate[lang]?.last_name}
											type="text"
											placeholder={Translate[lang]?.last_name}
											bsSize="lg"
											name="last_name"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.last_name}
											onChange={(e) =>
												setFormData({ ...formData, last_name: e.target.value })
											}
										/>
									</Col>
									<Col md={6}>
										<AvField
											label={Translate[lang]?.date_of_birth}
											type="date"
											placeholder={Translate[lang]?.date_of_birth}
											bsSize="lg"
											name="date_of_birth"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.date_of_birth}
											onChange={(e) =>
												setFormData({
													...formData,
													date_of_birth: e.target.value,
												})
											}
										/>
									</Col>
									<Col md={6}>
										<label className="d-block">{Translate[lang]?.gender}</label>
										<Select options={options} value={formData?.gender} />
									</Col>
									<Col md={6}>
										<AvField
											label={`${Translate[lang]?.employee} ID`}
											type="text"
											placeholder={`${Translate[lang]?.employee} ID`}
											bsSize="lg"
											name="employee_id"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.employee_id}
											onChange={(e) =>
												setFormData({
													...formData,
													employee_id: e.target.value,
												})
											}
										/>
									</Col>
									<Col md={6}>
										<AvField
											label={Translate[lang]?.date_of_join}
											type="date"
											placeholder={Translate[lang]?.date_of_join}
											bsSize="lg"
											name="date_of_join"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.date_of_join}
											onChange={(e) =>
												setFormData({
													...formData,
													date_of_join: e.target.value,
												})
											}
										/>
									</Col>
									<Col md={6}>
										<AvField
											label={Translate[lang]?.phone}
											type="text"
											placeholder={Translate[lang]?.phone}
											bsSize="lg"
											name="phone"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.phone}
											onChange={(e) =>
												setFormData({ ...formData, phone: e.target.value })
											}
										/>
									</Col>
									<Col md={6}>
										<AvField
											label={Translate[lang]?.email}
											type="email"
											placeholder={Translate[lang]?.email}
											bsSize="lg"
											name="email"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.email}
											onChange={(e) =>
												setFormData({ ...formData, email: e.target.value })
											}
										/>
									</Col>
									<Col md={12}>
										<label className="d-block">
											{Translate[lang]?.address}
										</label>
										<textarea
											className="w-100 py-2 px-3"
											placeholder={Translate[lang]?.address}
											style={{
												border: "1px solid hsl(0, 0%, 80%)",
												borderRadius: "10px",
												minHeight: "100px",
												maxHeight: "100px",
											}}
											value={formData?.address}
											onChange={(e) =>
												setFormData({ ...formData, address: e.target.value })
											}
										/>
									</Col>
									<Col md={6}>
										<AvField
											label={Translate[lang]?.department}
											type="text"
											placeholder={Translate[lang]?.department}
											bsSize="lg"
											name="department"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.department}
											onChange={(e) =>
												setFormData({ ...formData, department: e.target.value })
											}
										/>
									</Col>
									<Col md={6}>
										<AvField
											label={Translate[lang]?.employee_designation}
											type="text"
											placeholder={Translate[lang]?.employee_designation}
											bsSize="lg"
											name="employee_designation"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.employee_designation}
											onChange={(e) =>
												setFormData({
													...formData,
													employee_designation: e.target.value,
												})
											}
										/>
									</Col>
								</Row>
							</Card.Body>
						</Card>
					)}
					{type === "education_qualification" && (
						<div>
							<Card className="mb-3">
								<Card.Body>
									<Row>
										<Col md={12} className="fw-500 mb-2 text-black fs-18">
											{Translate[lang].higher_degree}
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.institution_name}
												type="text"
												placeholder={Translate[lang]?.institution_name}
												bsSize="lg"
												name="institution_name"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.institution_name}
												onChange={(e) =>
													setFormData({
														...formData,
														institution_name: e.target.value,
													})
												}
											/>
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.degree}
												type="text"
												placeholder={Translate[lang]?.degree}
												bsSize="lg"
												name="degree"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.degree}
												onChange={(e) =>
													setFormData({ ...formData, degree: e.target.value })
												}
											/>
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.starting_date}
												type="date"
												placeholder={Translate[lang]?.starting_date}
												bsSize="lg"
												name="starting_date"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.starting_date}
												onChange={(e) =>
													setFormData({
														...formData,
														starting_date: e.target.value,
													})
												}
											/>
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.complete_date}
												type="date"
												placeholder={Translate[lang]?.complete_date}
												bsSize="lg"
												name="complete_date"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.complete_date}
												onChange={(e) =>
													setFormData({
														...formData,
														complete_date: e.target.value,
													})
												}
											/>
										</Col>
									</Row>
								</Card.Body>
							</Card>
							<Card className="mb-3">
								<Card.Body>
									<Row>
										<Col md={12} className="fw-500 mb-2 text-black fs-18">
											{Translate[lang].bachelor_degree}
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.institution_name}
												type="text"
												placeholder={Translate[lang]?.institution_name}
												bsSize="lg"
												name="institution_name"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.institution_name}
												onChange={(e) =>
													setFormData({
														...formData,
														institution_name: e.target.value,
													})
												}
											/>
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.degree}
												type="text"
												placeholder={Translate[lang]?.degree}
												bsSize="lg"
												name="degree"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.degree}
												onChange={(e) =>
													setFormData({ ...formData, degree: e.target.value })
												}
											/>
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.starting_date}
												type="date"
												placeholder={Translate[lang]?.starting_date}
												bsSize="lg"
												name="starting_date"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.starting_date}
												onChange={(e) =>
													setFormData({
														...formData,
														starting_date: e.target.value,
													})
												}
											/>
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.complete_date}
												type="date"
												placeholder={Translate[lang]?.complete_date}
												bsSize="lg"
												name="complete_date"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.complete_date}
												onChange={(e) =>
													setFormData({
														...formData,
														complete_date: e.target.value,
													})
												}
											/>
										</Col>
									</Row>
								</Card.Body>
							</Card>
							<Card>
								<Card.Body>
									<Row>
										<Col md={12} className="fw-500 mb-2 text-black fs-18">
											{Translate[lang].secondary_degree}
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.institution_name}
												type="text"
												placeholder={Translate[lang]?.institution_name}
												bsSize="lg"
												name="institution_name"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.institution_name}
												onChange={(e) =>
													setFormData({
														...formData,
														institution_name: e.target.value,
													})
												}
											/>
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.degree}
												type="text"
												placeholder={Translate[lang]?.degree}
												bsSize="lg"
												name="degree"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.degree}
												onChange={(e) =>
													setFormData({ ...formData, degree: e.target.value })
												}
											/>
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.starting_date}
												type="date"
												placeholder={Translate[lang]?.starting_date}
												bsSize="lg"
												name="starting_date"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.starting_date}
												onChange={(e) =>
													setFormData({
														...formData,
														starting_date: e.target.value,
													})
												}
											/>
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.complete_date}
												type="date"
												placeholder={Translate[lang]?.complete_date}
												bsSize="lg"
												name="complete_date"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.complete_date}
												onChange={(e) =>
													setFormData({
														...formData,
														complete_date: e.target.value,
													})
												}
											/>
										</Col>
									</Row>
								</Card.Body>
							</Card>
						</div>
					)}
					{type === "experience_details" && (
						<div>
							<Card className="mb-3">
								<Card.Body>
									<Row>
										<Col md={12} className="fw-500 mb-2 text-black fs-18">
											{Translate[lang].company} 1
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.institution_name}
												type="text"
												placeholder={Translate[lang]?.institution_name}
												bsSize="lg"
												name="institution_name"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.institution_name}
												onChange={(e) =>
													setFormData({
														...formData,
														institution_name: e.target.value,
													})
												}
											/>
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.degree}
												type="text"
												placeholder={Translate[lang]?.degree}
												bsSize="lg"
												name="degree"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.degree}
												onChange={(e) =>
													setFormData({ ...formData, degree: e.target.value })
												}
											/>
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.starting_date}
												type="date"
												placeholder={Translate[lang]?.starting_date}
												bsSize="lg"
												name="starting_date"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.starting_date}
												onChange={(e) =>
													setFormData({
														...formData,
														starting_date: e.target.value,
													})
												}
											/>
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.complete_date}
												type="date"
												placeholder={Translate[lang]?.complete_date}
												bsSize="lg"
												name="complete_date"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.complete_date}
												onChange={(e) =>
													setFormData({
														...formData,
														complete_date: e.target.value,
													})
												}
											/>
										</Col>
									</Row>
								</Card.Body>
							</Card>
							<Card className="mb-3">
								<Card.Body>
									<Row>
										<Col md={12} className="fw-500 mb-2 text-black fs-18">
											{Translate[lang].company} 2
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.institution_name}
												type="text"
												placeholder={Translate[lang]?.institution_name}
												bsSize="lg"
												name="institution_name"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.institution_name}
												onChange={(e) =>
													setFormData({
														...formData,
														institution_name: e.target.value,
													})
												}
											/>
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.degree}
												type="text"
												placeholder={Translate[lang]?.degree}
												bsSize="lg"
												name="degree"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.degree}
												onChange={(e) =>
													setFormData({ ...formData, degree: e.target.value })
												}
											/>
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.starting_date}
												type="date"
												placeholder={Translate[lang]?.starting_date}
												bsSize="lg"
												name="starting_date"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.starting_date}
												onChange={(e) =>
													setFormData({
														...formData,
														starting_date: e.target.value,
													})
												}
											/>
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.complete_date}
												type="date"
												placeholder={Translate[lang]?.complete_date}
												bsSize="lg"
												name="complete_date"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.complete_date}
												onChange={(e) =>
													setFormData({
														...formData,
														complete_date: e.target.value,
													})
												}
											/>
										</Col>
									</Row>
								</Card.Body>
							</Card>
							<Card>
								<Card.Body>
									<Row>
										<Col md={12} className="fw-500 mb-2 text-black fs-18">
											{Translate[lang].company} 3
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.institution_name}
												type="text"
												placeholder={Translate[lang]?.institution_name}
												bsSize="lg"
												name="institution_name"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.institution_name}
												onChange={(e) =>
													setFormData({
														...formData,
														institution_name: e.target.value,
													})
												}
											/>
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.degree}
												type="text"
												placeholder={Translate[lang]?.degree}
												bsSize="lg"
												name="degree"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.degree}
												onChange={(e) =>
													setFormData({ ...formData, degree: e.target.value })
												}
											/>
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.starting_date}
												type="date"
												placeholder={Translate[lang]?.starting_date}
												bsSize="lg"
												name="starting_date"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.starting_date}
												onChange={(e) =>
													setFormData({
														...formData,
														starting_date: e.target.value,
													})
												}
											/>
										</Col>
										<Col md={6}>
											<AvField
												label={Translate[lang]?.complete_date}
												type="date"
												placeholder={Translate[lang]?.complete_date}
												bsSize="lg"
												name="complete_date"
												validate={{
													required: {
														value: true,
														errorMessage: Translate[lang].field_required,
													},
												}}
												value={formData.complete_date}
												onChange={(e) =>
													setFormData({
														...formData,
														complete_date: e.target.value,
													})
												}
											/>
										</Col>
									</Row>
								</Card.Body>
							</Card>
						</div>
					)}
					{type === "bank_account" && (
						<Card>
							<Card.Body>
								<Row>
									<Col md={12}>
										<AvField
											label={Translate[lang]?.account_name}
											type="text"
											placeholder={Translate[lang]?.account_name}
											bsSize="lg"
											name="account_name"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.account_name}
											onChange={(e) =>
												setFormData({
													...formData,
													account_name: e.target.value,
												})
											}
										/>
									</Col>
									<Col md={12}>
										<AvField
											label={Translate[lang]?.account_number}
											type="text"
											placeholder={Translate[lang]?.account_number}
											bsSize="lg"
											name="account_number"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.account_number}
											onChange={(e) =>
												setFormData({
													...formData,
													account_number: e.target.value,
												})
											}
										/>
									</Col>
									<Col md={12}>
										<AvField
											label={Translate[lang]?.account_number}
											type="text"
											placeholder={Translate[lang]?.account_number}
											bsSize="lg"
											name="account_number"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.account_number}
											onChange={(e) =>
												setFormData({
													...formData,
													account_number: e.target.value,
												})
											}
										/>
									</Col>
								</Row>
							</Card.Body>
						</Card>
					)}
					{type === "passport_information" && (
						<Card>
							<Card.Body>
								<Row>
									<Col md={12}>
										<AvField
											label={Translate[lang]?.passport_number}
											type="text"
											placeholder={Translate[lang]?.passport_number}
											bsSize="lg"
											name="passport_number"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.passport_number}
											onChange={(e) =>
												setFormData({
													...formData,
													passport_number: e.target.value,
												})
											}
										/>
									</Col>
									<Col md={12}>
										<AvField
											label={Translate[lang]?.nationality}
											type="text"
											placeholder={Translate[lang]?.nationality}
											bsSize="lg"
											name="nationality"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.nationality}
											onChange={(e) =>
												setFormData({
													...formData,
													nationality: e.target.value,
												})
											}
										/>
									</Col>
									<Col md={12}>
										<AvField
											label={Translate[lang]?.passport_no}
											type="text"
											placeholder={Translate[lang]?.passport_no}
											bsSize="lg"
											name="passport_no"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.passport_no}
											onChange={(e) =>
												setFormData({
													...formData,
													passport_no: e.target.value,
												})
											}
										/>
									</Col>
									<Col md={12}>
										<AvField
											label={Translate[lang]?.passport_expiry_date}
											type="date"
											placeholder={Translate[lang]?.passport_expiry_date}
											bsSize="lg"
											name="passport_expiry_date"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.passport_expiry_date}
											onChange={(e) =>
												setFormData({
													...formData,
													passport_expiry_date: e.target.value,
												})
											}
										/>
									</Col>
								</Row>
							</Card.Body>
						</Card>
					)}
					{type === "social" && (
						<Card>
							<Card.Body>
								<Row>
									<Col md={12}>
										<AvField
											label={Translate[lang]?.linked_in}
											type="text"
											placeholder={Translate[lang]?.linked_in}
											bsSize="lg"
											name="linked_in"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.linked_in}
											onChange={(e) =>
												setFormData({
													...formData,
													linked_in: e.target.value,
												})
											}
										/>
									</Col>
									<Col md={12}>
										<AvField
											label={Translate[lang]?.telegram}
											type="text"
											placeholder={Translate[lang]?.telegram}
											bsSize="lg"
											name="telegram"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.telegram}
											onChange={(e) =>
												setFormData({
													...formData,
													telegram: e.target.value,
												})
											}
										/>
									</Col>
									<Col md={12}>
										<AvField
											label={Translate[lang]?.tiktok}
											type="text"
											placeholder={Translate[lang]?.tiktok}
											bsSize="lg"
											name="tiktok"
											validate={{
												required: {
													value: true,
													errorMessage: Translate[lang].field_required,
												},
											}}
											value={formData.tiktok}
											onChange={(e) =>
												setFormData({
													...formData,
													tiktok: e.target.value,
												})
											}
										/>
									</Col>
								</Row>
							</Card.Body>
						</Card>
					)}
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="primary"
						type="submit"
						className="m-auto"
						disabled={loading}>
						{Translate[lang]?.edit}{" "}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default EditEmployeeModal;
